import React from 'react';
import axios from 'axios';
import Cart from '../../routes/newCart/NewCart';
// import Cart from '../../routes/cart/Cart';
import { setUserInfo, clearInfo } from '../../features-slice/user/userSlice';
import { DropdownButton, Dropdown, Navbar, Nav } from 'react-bootstrap';
import { logout, isAuthenticated } from '../../utils/auth/auth';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import logo from '../../assets/logoheader.png';
import bolsita from '../../assets/BOLSA_CARRITO_GRIS.png';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavBarNew.Module.css';
import { agregarAlCarrito } from '../../features-slice/cart/carritoSlice';
import { decodificarToken } from '../../utils/cart/cart';
import { getSales } from '../../utils/products/products';
import { useMediaQuery } from 'react-responsive';
import MenuIcon from '@mui/icons-material/Menu';
import Carousel from 'react-multi-carousel';
import {
  Typography, Box, Dialog, DialogContent, Button, Menu, MenuItem,
  TextField, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow,
  TableContainer, Paper, Checkbox
} from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import comunity from "../../assets/Link menu.png";
import pickup from "../../assets/Button menu.png";
import cart from "../../assets/Shopnew.png";
import MegaMenuMobile from '../megaMenu/MegaMenuMobile';
import MegaMenu from '../megaMenu/MegaMenu';

function NavBarNew({ tipoUsuario, nombre, puntos, isCatalogue }) {
  const bannerText = ["3 CUOTAS SIN INTERES CON BBVA", "3 CUOTAS SIN INTERES CON BANCO GALICIA", "30% DE REINTEGRO CON BBVA", "ENVIOS GRATIS A PARTIR DE $99.999"];
  const [currentBanner, setCurrentBanner] = React.useState(0);
  const carrito = useSelector((state) => state.carrito);
  const isMobile = useMediaQuery({ maxWidth: "900px" });
  const user = useSelector((state) => state.user.userInfo);
  const idUsuario = localStorage.getItem('Usuario');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openDialogPickup, setOpenDialogPickup] = React.useState(false);
  const [termino, setTermino] = React.useState('');

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleSearch = (e) => setTermino(e.target.value);
  const CATALOGUE_ID = '64ef4986d269731b208134bf';

  const handleSearchTerm = (e) => {
    e?.preventDefault?.();
    const q = (termino || '').trim();
    const sp = new URLSearchParams();
    sp.set('nombre', 'MARKET');
    if (q.length) sp.set('q', q);
    navigate(`/market/categoria/${CATALOGUE_ID}?${sp.toString()}`);
  };

  const [sales, setSales] = React.useState([]);
  const [userLoading, setUserLoading] = React.useState(true);
  const isMobileScreen = useMediaQuery({ maxWidth: 700 });
  const isMediumScreen = useMediaQuery({ maxWidth: 1100 });
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1, slidesToSlide: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1, slidesToSlide: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1, slidesToSlide: 1 },
  };

  const titleDrop = () => <PersonOutlineIcon />;

  React.useEffect(() => {
    if (isAuthenticated() && !user.role) {
      async function recargarEstado() {
        try {
          const userQuery = await axios.get(`${process.env.REACT_APP_BACK_URL}/api/usuarios/${idUsuario}`);
          dispatch(setUserInfo(userQuery.data));
        } catch (error) {
          console.log(error.response?.data?.errors?.[0]?.msg);
        } finally {
          setUserLoading(false);
        }
      }
      recargarEstado();
    }
  }, [user]);

  React.useEffect(() => {
    localStorage.setItem("Termino", "");
  }, []);

  function comprobarToken() {
    const carritoToken = localStorage.getItem('cc');
    if (carritoToken) {
      const carritoDecodificado = decodificarToken();
      carritoDecodificado.forEach((item) => {
        dispatch(agregarAlCarrito(item));
      });
    }
  }

  React.useEffect(() => {
    if (!isAuthenticated()) {
      logout();
    }
    comprobarToken();
  }, [carrito]);

  const cerrarSesion = (e) => {
    e.preventDefault();
    window.location.replace('/');
    setTimeout(() => {
      dispatch(clearInfo());
    }, 1500);
    logout();
  };

  const [showCart, setShowCart] = React.useState(false);
  const handleCloseCart = () => setShowCart(false);
  const handleOpenCart = () => setShowCart(true);

  const [expandedNav, setExpandedNav] = React.useState(false);
  const handleClickMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const handleOpenDialogPickup = () => setOpenDialogPickup(!openDialogPickup);

  React.useEffect(() => {
    async function getOfertas() {
      setSales(await getSales());
    }
    getOfertas();
    window.addEventListener('actualizar-producto', getOfertas);
    return () => window.removeEventListener('actualizar-producto', getOfertas);
  }, []);

  // ------------------- Exportar productos (Dialog + lógica) -------------------
  const [openExportDialog, setOpenExportDialog] = React.useState(false);
  const [expLoading, setExpLoading] = React.useState(false);
  const [expError, setExpError] = React.useState(null);
  const [expProductos, setExpProductos] = React.useState([]);
  const [expTotal, setExpTotal] = React.useState(0);
  const [expFilters, setExpFilters] = React.useState({
    marca: '',
    tags: '',
    vegan: false,
  });
  const DEBOUNCE_MS = 400;
  const expTimerRef = React.useRef(null);
  const BACK_URL = process.env.REACT_APP_BACK_URL;

  const fetchExportData = async () => {
    try {
      setExpLoading(true);
      setExpError(null);
      const params = {};
      if (expFilters.marca.trim()) params.marca = expFilters.marca.trim();
      if (expFilters.tags.trim()) params.tags = expFilters.tags.trim();
      if (expFilters.vegan) params.vegan = 'true';

      const { data } = await axios.get(`${BACK_URL}/api/productos/export`, { params });
      setExpProductos(Array.isArray(data?.productos) ? data.productos : []);
      setExpTotal(Number(data?.total) || 0);
    } catch (e) {
      console.error(e);
      setExpError('No se pudo cargar el listado para exportar.');
    } finally {
      setExpLoading(false);
    }
  };

  React.useEffect(() => {
    if (!openExportDialog) return;
    clearTimeout(expTimerRef.current);
    expTimerRef.current = setTimeout(() => {
      fetchExportData();
    }, DEBOUNCE_MS);
    return () => clearTimeout(expTimerRef.current);
  }, [openExportDialog, expFilters.marca, expFilters.tags, expFilters.vegan]);

  const handleOpenExportDialog = () => {
    setOpenExportDialog(true);
    setTimeout(fetchExportData, 0);
  };
  const handleCloseExportDialog = () => setOpenExportDialog(false);

  // Aplana a filas por variante (o una fila por producto sin variantes)
  const buildVariantRows = (productos = []) => {
    const rows = [];
    productos.forEach((p) => {
      const hasVar = Array.isArray(p.variantes) && p.variantes.length > 0;
      if (hasVar) {
        p.variantes.forEach((v, idx) => {
          rows.push({
        
            nombre: p?.nombre || '',
            marca: p?.marca || '',
            categoria: p?.categoria?.nombre || '',
            variante: v?.color || '',
            stock: Number(v?.disponibles ?? 0),
            precioEfectivo: p?.precioEfectivo ?? '',
            precioTarjeta: p?.precioTarjeta ?? '',
            precioOferta: p?.precioOferta ?? '',
            vegan: !!p?.vegan,
            tags: Array.isArray(p?.tags) ? p.tags.join(', ') : '',
            tags2: Array.isArray(p?.tags2) ? p.tags2.join(', ') : '',
          });
        });
      } else {
        rows.push({
        
          nombre: p?.nombre || '',
          marca: p?.marca || '',
          categoria: p?.categoria?.nombre || '',
          variante: '',
          stock: Number(p?.disponibles ?? 0),
          precioEfectivo: p?.precioEfectivo ?? '',
          precioTarjeta: p?.precioTarjeta ?? '',
          precioOferta: p?.precioOferta ?? '',
          vegan: !!p?.vegan,
          tags: Array.isArray(p?.tags) ? p.tags.join(', ') : '',
          tags2: Array.isArray(p?.tags2) ? p.tags2.join(', ') : '',
        });
      }
    });
    return rows;
  };

  const expRows = React.useMemo(() => buildVariantRows(expProductos), [expProductos]);

  const handleExportExcel = async () => {
    try {
      const XLSX = await import('xlsx'); // npm i xlsx
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(expRows);
      XLSX.utils.book_append_sheet(wb, ws, 'Productos');
      const stamp = new Date().toISOString().slice(0, 16).replace('T', '_').replace(':', '-');
      const hint = expFilters.marca ? `_${expFilters.marca}` : (expFilters.tags ? `_tags` : '');
      XLSX.writeFile(wb, `productos${hint}_${stamp}.xlsx`);
    } catch (e) {
      console.error(e);
      alert('No se pudo generar el Excel.');
    }
  };
  // ---------------------------------------------------------------------------

  return (
    <Box style={{ display: "flex", flexDirection: "column", position: "absolute", zIndex: 2000000 }}>
      <Box style={{ height: "43px", width: "100vw", marginTop: "0px" }}>
        <Carousel
          draggable={true}
          showDots={false}
          swipeable={true}
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          keyBoardControl={true}
          autoPlaySpeed={3000}
          shouldResetAutoplay={false}
          pauseOnHover={false}
          removeArrowOnDeviceType={['tablet', 'mobile', 'desktop']}
        >
          {bannerText?.map((texto, index) => (
            <Box
              key={index}
              sx={{
                height: "45px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#23563F",
                zIndex: 2,
                top: "-5px",
                color: "#ffff",
                fontWeight: 700,
                fontSize: !isMobile ? "16px" : "12px",
                fontFamily: "poppins",
                textAlign: "center"
              }}
            >
              {texto}
            </Box>
          ))}
        </Carousel>
      </Box>

      <div className='navbar navbar-expand-md border-bottom divNavBar' style={{ zIndex: 2000000 }}>
        <Cart handleCloseCart={handleCloseCart} handleOpenCart={handleOpenCart} showCart={showCart} />
        <Navbar
          expanded={expandedNav}
          onToggle={() => setExpandedNav(prev => !prev)}
          expand='lg'
          className='container-fluid justify-content-space-between navbaaar'
          style={{ zIndex: 4000000 }}
        >
          <div style={{ display: "flex" }}>
            {isMobileScreen && (
              <Navbar.Toggle className='border-0 ml-auto' style={{ backgroundColor: "white" }}>
                <MenuIcon style={{ fontSize: '30px', color: '#565862' }} />
              </Navbar.Toggle>
            )}
            <Navbar.Brand href='/markethome' className='logo mr-auto'>
              <img src={logo} alt='Logo LABeautiqueria Market' />
            </Navbar.Brand>

            {isMobileScreen && (
              <div style={{ position: "relative" }} className='nav-link linkNavBar bolsita'>
                <img
                  src={bolsita}
                  onClick={handleOpenCart}
                  alt='bolsita'
                  style={{ width: '45px', padding: '0 5px' }}
                />
                {carrito?.length ? (
                  <span
                    className='enCarrito badge'
                    style={{
                      position: 'absolute',
                      top: '24px',
                      left: '2px',
                      backgroundColor: '#E04D4D',
                      color: 'white',
                      borderRadius: '50%',
                      padding: '4px 7px',
                      fontSize: '10px',
                      fontWeight: 'bold',
                      lineHeight: 1,
                      zIndex: 10,
                    }}
                  >
                    {carrito.length}
                  </span>
                ) : null}
              </div>
            )}
          </div>

          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='ml-auto nav nav-pills navbar-nav me-auto mb-2 mb-md-0 '>
              <section style={{ display: "flex", flexDirection: !isMobileScreen ? "row" : "column-reverse", justifyContent: "space-between", alignItems: !isMobileScreen ? "center" : "flex-start", marginTop: isMobileScreen && "2vh", marginLeft: !isMobileScreen ? "5vw" : "", gap: "25px" }}>
                {isCatalogue && (<Box><Box sx={{ width: "33vw" }}></Box></Box>)}

                {!isMobileScreen && !isCatalogue && (
                  <Box>
                    <Box sx={{ width: "25vw" }}>
                      <form
                        style={{ display: "flex", alignItems: "center" }}
                        className='form-group has-feedback'
                        role='search'
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (termino.length >= 2 || termino === '') handleSearchTerm();
                        }}
                      >
                        <input
                          style={{ paddingLeft: "35px", borderRadius: "20px", fontFamily: "Poppins" }}
                          className='form-control me-2 '
                          type='search'
                          placeholder='Buscar'
                          value={termino}
                          onChange={handleSearch}
                        />
                        <i style={{ fontSize: "20px" }} className='bx bx-search form-control-feedback'></i>
                      </form>
                    </Box>
                  </Box>
                )}

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {!isMobileScreen && (
                    <Link
                      to="/market/categoria/64ef4986d269731b208134bf?nombre=MARKET"
                      style={{ fontSize: "14px", color: "#565862", textDecoration: "none" }}
                    >
                      <img
                        src={cart}
                        alt="community button"
                        style={{
                          height: isMediumScreen ? "15px" : "25px",
                          marginBottom: "3px",
                          marginRight: "20px",
                          transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                      />
                    </Link>
                  )}
                  <img style={{ height: isMediumScreen ? "35px" : "60px", cursor: "pointer" }} onClick={handleOpenDialogPickup} src={pickup} alt='pickup button' />
                  <Link style={{ fontSize: "14px", color: "#565862", textDecoration: "none" }} to='/alianzas' className='linkNavBarMarket'>
                    <img style={{ height: isMediumScreen ? "35px" : "60px", }} src={comunity} alt="community button" />
                  </Link>
                </Box>

                {user.role !== undefined ? (
                  <>
                    <Button
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : 'undefined'}
                      onClick={handleClickMenu}
                      className='dropdowncitoB'
                    >
                      {titleDrop()}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseMenu}
                      MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                    >
                      {(user.role === 'ADMIN_ROLE' || user.role === 'SUPERADMIN_ROLE') && (
                        <MenuItem onClick={handleCloseMenu} component={Link} to="/dashboard"><Typography sx={{ color: "#474747" }}>Dashboard</Typography></MenuItem>
                      )}
                      {user.role === 'SUPERADMIN_ROLE' && (
                        <MenuItem onClick={handleCloseMenu} component={Link} to="/stats"><Typography sx={{ color: "#474747" }}>Estadísticas</Typography></MenuItem>
                      )}
                      {(user.role === 'ADMIN_ROLE' || user.role === 'SUPERADMIN_ROLE') && (
                        <MenuItem onClick={handleCloseMenu} component={Link} to="/cajadiaria"><Typography sx={{ color: "#474747" }}>Caja diaria</Typography></MenuItem>
                      )}
                      {(user.role === 'ADMIN_ROLE' || user.role === 'SUPERADMIN_ROLE') && (
                        <MenuItem onClick={handleCloseMenu} component={Link} to="/iniciarSesion"><Typography sx={{ color: "#474747" }}>Pantalla Login</Typography></MenuItem>
                      )}

                      {/* NUEVO: Exportar productos */}
                      {(user.role === 'SUPERADMIN_ROLE') && (
                        <MenuItem onClick={() => { handleCloseMenu(); handleOpenExportDialog(); }}>
                          <Typography sx={{ color: "#474747" }}>Exportar productos</Typography>
                        </MenuItem>
                      )}

                      <MenuItem onClick={handleCloseMenu} component={Link} to="/perfil">
                        <Typography sx={{ color: "#474747" }}>Mi perfil</Typography>
                      </MenuItem>
                      <MenuItem
                        onClick={(e) => {
                          cerrarSesion(e);
                          handleCloseMenu();
                        }}
                      >Cerrar sesión</MenuItem>
                    </Menu>
                  </>
                ) : (
                  <div className='iniciarSesion'>
                    <Link to={'/iniciarSesion'} className='iniciarSesionLink'>
                      <PersonOutlineIcon />
                    </Link>
                  </div>
                )}

                {!isMobileScreen && (
                  <div className='nav-link linkNavBar bolsita'>
                    <img
                      src={bolsita}
                      onClick={handleOpenCart}
                      alt='bolsita'
                      style={{ width: '60px', padding: '0 5px' }}
                    />
                    {carrito?.length ? <span className='enCarrito badge'>{carrito?.length}</span> : ''}
                  </div>
                )}

                {isMobileScreen && (
                  <Box sx={{ width: "90vw", paddingBottom: "1vh" }}>
                    <MegaMenuMobile isCatalogue={isCatalogue} expandedNav={expandedNav} setExpandedNav={setExpandedNav} />
                  </Box>
                )}
              </section>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        {isMobileScreen && !isCatalogue && (
          <Box sx={{ width: "90vw", paddingBottom: "1vh" }}>
            <form
              style={{ display: "flex", alignItems: "center" }}
              className='form-group has-feedback'
              role='search'
              onSubmit={(e) => {
                e.preventDefault();
                if (termino.length >= 2 || termino === '') handleSearchTerm();
              }}
            >
              <input
                style={{ paddingLeft: "35px", borderRadius: "20px", fontFamily: "Poppins" }}
                className='form-control me-2 '
                type='search'
                placeholder='Buscar'
                value={termino}
                onChange={handleSearch}
              />
              <i style={{ fontSize: "20px" }} className='bx bx-search form-control-feedback'></i>
            </form>
          </Box>
        )}
      </div>

      {/* Dialog: PickUp */}
      <Dialog sx={{ minWidth: "50vw" }} open={openDialogPickup} onClose={handleOpenDialogPickup}>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "25px" }}>
            <Typography style={{ fontFamily: "Poppins", color: "#5c5c5c", fontSize: !isMobileScreen ? "28px" : "20px", marginButton: isMobileScreen ? "25px" : "15px" }} variant="h4" className="fade-in-contact">
              PickUp Point
            </Typography>
            <iframe
              style={{ width: "100%" }}
              title='mapa'
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3348.2036168518994!2d-60.65233098783957!3d-32.94563317172896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95b7abe22ab37481%3A0x91688815b66d30e0!2sLa%20Beautiqueria%20Nails%2C%20Beauty%20%26%20Market!5e0!3m2!1ses-419!2sar!4v1690300646710!5m2!1ses-419!2sar'
              loading='lazy'
            ></iframe>
            <Typography style={{ fontFamily: "Poppins", color: "#5c5c5c", fontSize: !isMobileScreen ? "18px" : "14px", marginBottom: "15px" }} variant="h4" className="fade-in-contact">
              Rioja 1917, Rosario - Santa Fe, Argentina
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>

      {/* MegaMenu desktop */}
      {!isMobile && !isCatalogue && (
        <Box style={{ height: "43px", width: "100vw", marginTop: "0px", zIndex: 10 }}>
          <MegaMenu />
        </Box>
      )}

      {/* Dialog: Exportar productos (con variantes + precios) */}
      <Dialog open={openExportDialog} onClose={handleCloseExportDialog} fullWidth maxWidth="lg">
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5" sx={{ fontFamily: 'Poppins', fontWeight: 600, color: '#474747' }}>
              Exportar productos
            </Typography>

            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 160px' }, gap: 2, alignItems: 'center' }}>
              <TextField
                label="Marca"
                size="small"
                value={expFilters.marca}
                onChange={(e) => setExpFilters(f => ({ ...f, marca: e.target.value.toUpperCase() }))}
                placeholder="Ej: LACA"
              />
              <TextField
                label="Tags (coma-separados)"
                size="small"
                value={expFilters.tags}
                onChange={(e) => setExpFilters(f => ({ ...f, tags: e.target.value }))}
                placeholder="Ej: Make Up,Accesorios"
              />
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Checkbox
                  checked={expFilters.vegan}
                  onChange={(e) => setExpFilters(f => ({ ...f, vegan: e.target.checked }))}
                />
                <Typography variant="body2">Sólo veganos</Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="body2" sx={{ color: '#666' }}>
                {expLoading ? 'Buscando…' : `Resultados: ${expTotal}`}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button variant="outlined" onClick={fetchExportData} disabled={expLoading}>
                  {expLoading ? 'Actualizando…' : 'Actualizar'}
                </Button>
                <Button variant="contained" onClick={handleExportExcel} disabled={expLoading || !expRows.length}>
                  Exportar Excel
                </Button>
              </Box>
            </Box>

            {expError && (
              <Typography variant="body2" color="error">{expError}</Typography>
            )}

            <TableContainer component={Paper} sx={{ maxHeight: 520 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Nombre</TableCell>
                    <TableCell>Marca</TableCell>
                    <TableCell>Categoría</TableCell>
                    <TableCell>Color / Variante</TableCell>
                    <TableCell align="right">Stock</TableCell>
                    <TableCell align="right">Precio Efectivo</TableCell>
                    <TableCell align="right">Precio Tarjeta</TableCell>
                    <TableCell align="right">Precio Oferta</TableCell>
                    <TableCell align="center">Vegan</TableCell>
                    <TableCell>Tags</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {expLoading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    (expRows || []).slice(0, 400).map((r) => (
                      <TableRow key={r.id} hover>
                        <TableCell>{r.nombre}</TableCell>
                        <TableCell>{r.marca}</TableCell>
                        <TableCell>{r.categoria}</TableCell>
                        <TableCell>{r.variante}</TableCell>
                        <TableCell align="right">{Number.isFinite(r.stock) ? r.stock : ''}</TableCell>
                        <TableCell align="right">{r.precioEfectivo}</TableCell>
                        <TableCell align="right">{r.precioTarjeta}</TableCell>
                        <TableCell align="right">{r.precioOferta}</TableCell>
                        <TableCell align="center">{r.vegan ? 'Sí' : 'No'}</TableCell>
                        <TableCell>{r.tags}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {!expLoading && expRows.length > 400 && (
              <Typography variant="caption" sx={{ color: '#999' }}>
                Mostrando 400 filas. El Excel incluirá todo.
              </Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default NavBarNew;
